import { Box } from "@mui/material"
import { FormSetup } from './form/Index'
import { Receipt } from "./form/Receipt"
import { useLocation } from "react-router-dom/cjs/react-router-dom.min"
import { useContext, useEffect, useState } from "react"
import { rqx } from '../../../core/request/API'
import { env } from "../../../core/Env"
import { ToolContext } from "../../../core/context/ToolContext"
import { SnakeLoader } from "../../../core/loader/SnakeLoader"

function useQuery() {
    return new URLSearchParams(useLocation().search)
}

export const MemberShip = () => {
    const { tool_state } = useContext(ToolContext)
    const urlParams = useQuery()
    const [info, setInfo] = useState({data: null, loader: true})
    const [isAvailed, setIsAvailed] = useState(false)

    useEffect(() => {
        try {
            const membershipDetails = async() => {
                setInfo((p) => (
                    {...p, loader: true}
                ))
                const r = await rqx.get(`<<tool>>/${env()}/membership/read`, { id: window.atob(urlParams.get('id')) })
                const s = await rqx.get(`<<tool>>/${env()}/membership/subscribed`, { user_id: tool_state.userId.data, membership_id: window.atob(urlParams.get('id')) })
                if (s) {
                    setIsAvailed(s.msg === "Ongoing Subscription")
                }
                const memshipInfo = {
                    ...r.data[0], 
                    inclusion: r.inclusions
                }
                setInfo((p) => (
                    {...p, data: memshipInfo, loader: false}
                ))
            }
            if (urlParams.get('steps') === 'pay') {
                membershipDetails()
            }
        } catch (error) {
            console.error('Failed to fetch membership details:', error);
        }
       // eslint-disable-next-line
    },[urlParams.get('steps')])
    
    return(
        <Box bgcolor="#fff" height="100dvh" width="100vw">
            {
                urlParams.get('steps') === 'pay' ?
                    info.loader ?
                        <Box height="100%" width="100%" display="flex" justifyContent="center" alignItems="center">
                            <SnakeLoader bg="#256EFF" size="12px" distance="7px" sx={{ mt: '1rem' }}/>
                        </Box>
                    :
                        <FormSetup info={info} tool_state={tool_state} isAvailed={isAvailed} />
                :
                    urlParams.get('steps') === 'receipt' ?
                        <Receipt urlParams={urlParams} />
                    :
                        <Box height="100%" display="flex" justifyContent="center" alignItems="center"> 
                            404 Page Not Found
                        </Box>
            }
        </Box>
    )
}